/** Optional official event integration. It never writes the cart or sets prices. */
export function installStandardEvents(events, scope = document) {
  if (globalThis.MeriStandardEvents) return;
  const readView = (element) => {
    try {
      return JSON.parse(element?.getAttribute('view-event-payload') || 'null');
    } catch {
      return null;
    }
  };
  function begin(EventClass, target, payload, cartOperation = false) {
    if (!EventClass || !target?.dispatchEvent) return null;
    let deferred,
      snapshot,
      finished = false;
    const observe = (event) => {
      snapshot = event.detail?.cart;
    };
    const cleanup = () => {
      finished = true;
      if (cartOperation) scope.removeEventListener('meri:cart:updated', observe);
    };
    try {
      deferred = EventClass.createPromise();
      // A theme still works when no app subscribes to the promise.
      deferred.promise.catch(() => {});
      if (cartOperation) scope.addEventListener('meri:cart:updated', observe);
      const event = new EventClass({ ...payload, promise: deferred.promise });
      event.promise?.catch(() => {});
      target.dispatchEvent(event);
    } catch (error) {
      cleanup();
      deferred?.reject(error);
      return null;
    }
    return {
      resolve(value) {
        if (finished) return;
        cleanup();
        try {
          deferred.resolve(
            cartOperation ? { cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(value) } : value,
          );
        } catch (error) {
          deferred.reject(error);
        }
      },
      reject(error) {
        if (finished) return;
        cleanup();
        try {
          if (cartOperation && error.code === 'rejected' && snapshot) {
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(snapshot),
              userErrors: [{ code: 'INVALID', field: [], message: error.message }],
            });
            return;
          }
          if (cartOperation)
            target.dispatchEvent(new events.CartErrorEvent({ error: error.message, code: 'SERVICE_UNAVAILABLE' }));
        } catch {
          /* An optional event listener cannot change the buying result. */
        }
        deferred.reject(error);
      },
    };
  }
  globalThis.MeriStandardEvents = {
    cart: (target, action, context, lines) =>
      begin(events.CartLinesUpdateEvent, target, { action, context, lines }, true),
    product(target, selectedOptions) {
      const data = readView(target);
      if (!data?.product || !selectedOptions.length) return null;
      const { id, title, handle } = data.product;
      return begin(events.ProductSelectEvent, target, {
        product: { id: String(id).startsWith('gid://') ? String(id) : `gid://shopify/Product/${id}`, title, handle },
        selectedOptions,
      });
    },
    variant: (target) => readView(target)?.product?.selectedVariant || null,
  };
  if (!customElements.get('meri-view-event')) customElements.define('meri-view-event', events.createViewEventElement());
  const pageView = () =>
    scope.dispatchEvent(
      new events.PageViewEvent({
        page: { template: scope.documentElement.dataset.template, title: scope.title, url: location.href },
      }),
    );
  if (scope.readyState === 'loading') scope.addEventListener('DOMContentLoaded', pageView, { once: true });
  else pageView();
}

// Optional library failure must not prevent the independent buying modules loading.
if (typeof document !== 'undefined') import('@shopify/standard-events').then(installStandardEvents).catch(() => {});
